import {formatNumber} from '../../../../explorer/components/common'

export function SlideSocioDemograficos(cacheResult, slideT) {
  const sociodemografico = cacheResult?.sociodemografico || []
  const getServico = (servicoName) => sociodemografico.find((item) => item.servico === servicoName)
  const getServicoItens = (servicoName) => getServico(servicoName)?.resultado?.itens || []
  const getServicoValue = (servicoName, variavel) =>
    getServico(servicoName)?.resultado?.itens?.[0]?.[variavel]
  const fixeText = (item) => {
    switch (item) {
      case 'S?O PAULO':
        return 'Sao Paulo'
      default:
        return item
    }
  }
  const formatValue = (value, style: any = 'inteiro') => {
    if (value === undefined || value === null || Number.isNaN(Number(value))) {
      return '-'
    }
    return formatNumber(value, style)
  }

  const densidadeValue = getServicoValue('renda-domiciliar-intersect', 'densidade_hab_ha')
  const densidadeLabel = (() => {
    const classificacao = Number(densidadeValue)
    if (!Number.isFinite(classificacao)) {
      return undefined
    }
    if (classificacao < 30) {
      return 'Muito Baixa'
    } else if (classificacao >= 30 && classificacao < 80) {
      return 'Baixa'
    } else if (classificacao >= 80 && classificacao < 150) {
      return 'Media'
    } else if (classificacao >= 150 && classificacao < 300) {
      return 'Alta'
    } else if (classificacao >= 300) {
      return 'Muito Alta'
    }
  })()

  function getdom_total() {
    const dom_total_2010 = Number(getServicoValue('renda-domiciliar-intersect', 'dom_total'))
    const dom_total_2022 = Number(getServicoValue('populacao-domicilios-censo-2022', 'domicilios'))
    if (!Number.isFinite(dom_total_2010) || dom_total_2010 === 0) {
      return 0
    }
    const percental = Math.round((dom_total_2022 / dom_total_2010 - 1) * 100)
    if (!Number.isFinite(percental)) {
      return 0
    }
    return percental
  }

  const faixasConfig = [
    ['Faixa 1', 0, 2850, 'faixa_14'],
    ['Faixa 2', 2850, 4700, 'faixa_15'],
    ['Faixa 3', 4700, 8600, 'faixa_16'],
    ['Faixa 4', 8600, 12000, 'faixa_17'],
    ['Media Alta Renda', 12000, 20000, 'faixa_18'],
    ['Alta Renda', 20000, 30000, 'faixa_19'],
    ['Altissima Renda', 30000, 0, 'faixa_20'],
  ]
  const faixasRenda = getServicoItens('dom-total-faixa-renda-v2')
    .map((item) => {
      const faixaMatch = faixasConfig.find((faixa) => faixa[3] === item.id_faixa)
      return {
        ...item,
        faixa_renda: faixaMatch ? faixaMatch[0] : item.faixa_renda,
      }
    })
    .filter((item) => item.faixa === 'baixa_renda')

  const ivsValue = getServicoValue('ivs', 'ivs')
  const indexValue = getServicoValue('supply-location-quality-index', 'index')
  const verticalizacaoValue = getServicoValue('indice-verticalizacao', 'indice_verticalizacao')
  const rendaMensalDomiciliar = getServicoItens('renda-mensal-domiciliar')
  const verticalizacaoText =
    verticalizacaoValue !== undefined && verticalizacaoValue !== null
      ? `${formatValue(verticalizacaoValue)}%`
      : '-'

  const rightX = 7.6
  const rightY = 1.4
  const rightW = 5.6
  const topH = 1.4
  const rowGap = 0.17
  const row1H = 1.6

  const borderColor = 'E6E6E6'
  const cardFill = 'FFFFFF'

  const addCard = ({
    x,
    y,
    w,
    h,
    title,
    subtitle,
    value,
    footer,
  }: {
    x: number
    y: number
    w: number
    h: number
    title?: string
    subtitle?: string
    value?: string
    footer?: string
  }) => {
    slideT.addShape('rect', {
      x,
      y,
      w,
      h,
      fill: {color: cardFill},
      line: {color: borderColor, pt: 1},
    })
    if (title) {
      slideT.addText(title, {
        x: x + 0.2,
        y: y + 0.15,
        w: w - 0.4,
        h: 0.3,
        fontSize: 12,
        color: '333333',
        bold: true,
        fontFace: 'Arial',
      })
    }
    if (subtitle) {
      slideT.addText(subtitle, {
        x: x + 0.2,
        y: y + 0.45,
        w: w - 0.4,
        h: 0.25,
        fontSize: 9,
        color: '999999',
        fontFace: 'Arial',
      })
    }
    if (value) {
      slideT.addText(value, {
        x: x + 0.2,
        y: y + h * 0.44,
        w: w - 0.4,
        h: 0.5,
        fontSize: 20,
        color: '666666',
        bold: true,
        align: 'center',
        fontFace: 'Arial',
      })
    }
    if (footer) {
      slideT.addText(footer, {
        x: x + 0.2,
        y: y + h - 0.49,
        w: w - 0.4,
        h: 0.3,
        fontSize: 10,
        color: '333333',
        align: 'center',
        fontFace: 'Arial',
      })
    }
  }

  slideT.addShape('rect', {
    x: rightX,
    y: rightY,
    w: rightW,
    h: topH,
    fill: {color: cardFill},
    line: {color: borderColor, pt: 1},
  })
  slideT.addText('Faixa de renda', {
    x: rightX + 0.2,
    y: rightY + 0.1,
    w: rightW - 0.4,
    h: 0.3,
    fontSize: 12,
    color: '333333',
    bold: true,
    fontFace: 'Arial',
  })

  const faixaTotal = faixasRenda.reduce((acc, item) => acc + Number(item.total_dom || 0), 0)
  const sortedFaixas = [...faixasRenda].sort((a, b) => Number(b.total_dom) - Number(a.total_dom))
  const faixaColors = ['FF0000', 'FFA500', 'FF0059', '008000', '0000FF', '4B0082', 'EE82EE']
  const barX = rightX + 0.2
  const barY = rightY + 0.55
  const barW = rightW - 0.4
  const barH = 0.28

  if (sortedFaixas.length === 0 || faixaTotal <= 0) {
    slideT.addShape('rect', {
      x: barX,
      y: barY,
      w: barW,
      h: barH,
      fill: {color: 'E0E0E0'},
      line: {color: 'E0E0E0'},
    })
  } else {
    let cursorX = barX
    sortedFaixas.forEach((faixa, index) => {
      const rawPercent = (Number(faixa.total_dom) / faixaTotal) * 100
      const percent = Math.round(rawPercent)
      const segW = Math.max((barW * rawPercent) / 100, 0.05)
      const color = faixaColors[index % faixaColors.length]
      slideT.addShape('rect', {
        x: cursorX,
        y: barY,
        w: segW,
        h: barH,
        fill: {color},
        line: {color},
      })
      slideT.addText(`${percent}%`, {
        x: cursorX,
        y: barY + 0.02,
        w: segW,
        h: barH,
        fontSize: 9,
        color: 'FFFFFF',
        bold: true,
        align: 'center',
        fontFace: 'Arial',
      })
      cursorX += segW
    })
  }

  const legendY = rightY + 0.92
  const legendStartX = rightX + 0.2
  const legendGap = 0.1
  let legendX = legendStartX
  sortedFaixas.slice(0, 5).forEach((faixa, index) => {
    const color = faixaColors[index % faixaColors.length]
    slideT.addShape('rect', {
      x: legendX,
      y: legendY,
      w: 0.12,
      h: 0.12,
      fill: {color},
      line: {color},
    })
    slideT.addText(faixa.faixa_renda, {
      x: legendX + 0.15,
      y: legendY - 0.02,
      w: 0.9,
      h: 0.2,
      fontSize: 8,
      color: '333333',
      fontFace: 'Arial',
    })
    legendX += 1.0 + legendGap
  })

  const cardW = (rightW - 0.4) / 3
  const row1Y = rightY + topH + rowGap
  const ivsText = ivsValue !== undefined ? `${formatValue(ivsValue, 'inteiro')}` : '-'

  addCard({
    x: rightX,
    y: row1Y,
    w: cardW,
    h: row1H,
    title: 'Vulnerabilidade Social',
    value: ivsText,
    footer: 'IVS',
  })
  addCard({
    x: rightX + cardW + 0.2,
    y: row1Y,
    w: cardW,
    h: row1H,
    title: 'Urbit Score',
    value: indexValue,
    footer: 'Urbit Score',
  })
  addCard({
    x: rightX + (cardW + 0.2) * 2,
    y: row1Y,
    w: cardW,
    h: row1H,
    title: 'Verticalizacao',
    value: verticalizacaoText,
    footer: 'Verticalizacao',
  })

  const row2Y = row1Y + row1H + rowGap
  const row2W = (rightW - 0.2) / 2
  const habitantes = getServicoValue('renda-domiciliar-intersect', 'pop_total')
  const rendaCards =
    rendaMensalDomiciliar.length === 1
      ? [
          {
            title: formatValue(rendaMensalDomiciliar?.[0]?.renda_mensal_domiciliar, 'currency_inteiro'),
            subtitle: 'Renda media domiciliar',
            footer: 'Data base dez/2025',
          },
        ]
      : rendaMensalDomiciliar.length > 1
        ? rendaMensalDomiciliar.map((item) => ({
            title: formatValue(item?.renda_mensal_domiciliar, 'currency_inteiro'),
            subtitle: `Renda media domiciliar em ${fixeText(item?.municipio || '')}`.trim(),
            footer: 'Data base dez/2025',
          }))
        : []

  const detailCards = [
    {
      title: densidadeValue ? `${densidadeValue} Hab/Ha` : '-',
      subtitle: `${densidadeLabel || ''} Densidade`.trim(),
      footer: 'Censo 2022',
    },
    ...rendaCards,
    {
      title: habitantes ? formatValue(habitantes, 'inteiro') : '-',
      subtitle: 'Habitantes',
      footer: 'Censo 2022',
    },
    {
      title: formatValue(getServicoValue('renda-domiciliar-intersect', 'dom_total'), 'inteiro'),
      subtitle: `Domicilios ${getdom_total()} %`,
      footer: 'Em comparacao a 2010',
    },
    {
      title: getServicoValue('renda-domiciliar-intersect', 'hab_dom'),
      subtitle: 'Hab. por dom',
    },
    {
      title: getServicoValue('renda-domiciliar-intersect', 'indice_envelhecimento'),
      subtitle: 'Indice de Envelhecimento',
    },
  ]

  const detailAreaBottom = 6.45
  const detailGap = 0.1
  const detailRows = Math.max(Math.ceil(detailCards.length / 2), 1)
  const detailCardH = Math.min(
    0.7,
    (detailAreaBottom - row2Y - detailGap * (detailRows - 1)) / detailRows
  )

  detailCards.forEach((card, index) => {
    const column = index % 2
    const row = Math.floor(index / 2)

    addCard({
      x: rightX + (row2W + 0.2) * column,
      y: row2Y + row * (detailCardH + detailGap),
      w: row2W,
      h: detailCardH,
      title: card.title,
      subtitle: card.subtitle,
      footer: card.footer,
    })
  })

  return null
}

